module.exports = __webpack_public_path__ + "img/logo-black.6f3368f.svg";